import React from "react";
import MsbTableSection from "./MsbTableSection";
import FolderNavigation from "./FolderNavigation";

function MsbTableWrapper() {

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="oct_treeview-container mt-2">
                        <FolderNavigation />
                        <div className="oct_content">
                            <MsbTableSection />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )


}

export default MsbTableWrapper;
